import { render } from "./CreateCampaign.vue?vue&type=template&id=44081b4f&scoped=true"
import script from "./CreateCampaign.vue?vue&type=script&lang=js"
export * from "./CreateCampaign.vue?vue&type=script&lang=js"

import "./CreateCampaign.vue?vue&type=style&index=0&id=44081b4f&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44081b4f"]])

export default __exports__